import { Alert, Grid, TextField } from '@mui/material'
import { FunctionComponent } from 'react'
import { Controller, UseFormReturn } from 'react-hook-form'

import { KardexPeriodoInput } from '../../../base/interfaces'

interface OwnProps {
  form: UseFormReturn<KardexPeriodoInput>
}

type Props = OwnProps

/**+
 * Formulario para iniciar kardex periodo
 * @param props
 * @constructor
 */
const KardexPeriodoForm: FunctionComponent<Props> = (props) => {
  const {
    form: {
      control,
      formState: { errors },
    },
  } = props

  return (
    <Grid container rowSpacing={2}>
      <Grid size={12}>
        <Alert severity="info">
          Ingrese la descripción corta del periodo de Kardex que desea iniciar. Ejemplo:
          2022-2023
        </Alert>
      </Grid>
      <Grid size={12}>
        <Controller
          name="descripcion"
          control={control}
          render={({ field }) => (
            <TextField
              {...field}
              value={field.value ?? ''} // Ensure value is not null
              label="Descripción"
              size="small"
              fullWidth
              multiline
              rows={4}
              error={!!errors.descripcion}
              helperText={errors.descripcion?.message}
            />
          )}
        />
      </Grid>
    </Grid>
  )
}

export default KardexPeriodoForm
